import { useTimezone } from '../contexts/TimezoneContext';
import { 
  formatToLocalTime, 
  formatRelativeTime, 
  formatNotificationTime 
} from '../utils/timezoneUtils';

/**
 * Custom hook for timezone-aware date formatting
 */
export const useTimezoneFormatting = () => {
  const { userTimezone } = useTimezone();

  return {
    // Format UTC timestamp to local time
    formatToLocal: (utcTimestamp: string, options?: Intl.DateTimeFormatOptions) => 
      formatToLocalTime(utcTimestamp, userTimezone, options),
    
    // Format UTC timestamp to relative time (e.g., "2 hours ago")
    formatRelative: (utcTimestamp: string) => 
      formatRelativeTime(utcTimestamp, userTimezone),
    
    // Format UTC timestamp for notifications
    formatNotification: (utcTimestamp: string) => 
      formatNotificationTime(utcTimestamp, userTimezone),
    
    // Get current timezone
    timezone: userTimezone,
  };
};
